import * as Sentry from '@sentry/react';
Sentry.init({
  dsn: 'https://257b7a8fde8ab3c6355e76ccaf891c0d@o292676.ingest.us.sentry.io/4507627214012416',
  enabled: import.meta.env.PROD,
});
